<template>
  <div>
    <el-row id="to-bottom">
      <el-col align="right">
        <el-tooltip class="item" effect="dark" :content="item.label" placement="top-end"
                    v-for="(item,index) in statuses" :key="index">

					<span v-if="item.id == 1 || item.id == 34">
						<el-button :type="item.type"
                       class="buttonFixed"
                       @click="submitForm(1,null)">
							{{ item.label }}
						</el-button>
					</span>

          <span v-if="item.id == 53 || item.id == 58">
						<el-button :type="item.type"
                       class="buttonFixed"
                       @click="specialService(item.id)">
							{{ item.label }}
						</el-button>
					</span>

          <span v-if="item.id == 52">
						<el-button :type="item.type"
                       class="buttonFixed"
                       @click="submitForm(51,null)">
							 {{ item.label }}
						</el-button>
					</span>

          <span v-if="item.id == 2 || item.id == 35"><!-- || item.id == 14 || item.id == 15-->
						<el-button :type="item.type"
                       class="buttonFixed"
                       @click="submitFormValidate(item.id, null)">
							{{ item.label }}
						</el-button>
					</span>

          <span v-if="item.id != 1 && item.id != 2 && item.id != 34 && item.id != 35 && item.id != 53&& item.id != 52"><!-- && item.id != 14 && item.id != 15-->
						<el-button :type="item.type"
                       class="buttonFixed"
                       @click="showDialogF(item.id)">
							{{ item.label }}
						</el-button>
					</span>

        </el-tooltip>

        <el-tooltip class="item" effect="dark" content="Up" placement="top-end">
          <el-button type="info"
                     plain
                     style="font-size: 20px !important;"
                     icon="el-icon-caret-top"
                     class="buttonFixed"
                     @click="goToUp">
          </el-button>
        </el-tooltip>

        <el-alert :closable="true"
                  type="info"
                  icon="el-icon-caret-top"
                  class="buttonFixed">
          <span style="font-size: 15px !important; font-weight: bold; color: black">
            {{ requestForm.folio ? 'Folio: ' + requestForm.folio : '' }}
          </span>
          <span style="color: black; font-size: 13px">|</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">
            Usuario creador:
          </span>
          <span style="font-size: 15px !important; font-weight: bold; color: black ">
            {{
              requestForm.last_log_register.user.full_name
            }}
          </span>
          <span style="color: black; font-size: 13px">|</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">Perfil:</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">
            {{
              requestForm.last_log_register.user.profile.name
            }}
          </span>
          <span style="color: black; font-size: 13px">|</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">Representación:</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">
            {{
              requestForm.office ? requestForm.office.representation_name : ''
            }}
          </span>
          <span style="color: black; font-size: 13px">|</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">Estatus:</span>
          <span style="font-size: 15px !important; font-weight: bold; color: black">{{
              requestForm.last_log.status.name
            }}</span>
        </el-alert>
      </el-col>
    </el-row>
    <el-dialog
        title="Agregar Comentarios"
        :visible.sync="showDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="80%">
      <el-input v-model="comments"
                type="textarea"
                :autosize="{ minRows: 8, maxRows: 8}"
                placeholder="Comentarios">
      </el-input>
      <el-tooltip class="item"
                  v-if="comments != null && comments.length > 3"
                  placement="top-start"
                  effect="dark"
                  content="Elija un valor para organizar sus favoritos.">
        <rate v-if="comments != null && comments.length > 3" :length="5" v-model="rate"/>
      </el-tooltip>
      <span slot="footer" class="dialog-footer">
        <el-table
            border
            sortable
            stripe
            v-if="allComments.length > 0"
            :data="allComments"
            size="small" style="width: 100%">
					<el-table-column type="index" label="#" align="center"/>
          <el-table-column label="Estrellas" align="center" prop="order" v-if="type != 3 && type != null">
            <template slot-scope="props">
              <rate :length="5" v-model="props.row.order" :disabled="true"/>
            </template>
          </el-table-column>
          <el-table-column label="Escrito por" prop="user.full_name"/>
          <el-table-column label="Perfil/Área" prop="user.profile.name"/>
					<el-table-column label="Comentario" prop="comment">
            <template slot-scope="props">
              <span style="font-size: 11pt !important; text-align: justify">
                {{ props.row.comment }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Acciones">
            <template slot-scope="props">
              <el-button
                  type="text"
                  icon="fas fa-check"
                  @click="comments = props.row.comment; allComments = []">
                Seleccionar
              </el-button>
              <el-button
                  type="text"
                  icon="fas fa-trash"
                  v-if="type != 3 && type != null"
                  @click="deleteComment(props.row)">
                Eliminar
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <br>
				<el-button
            icon="fas fa-share"
            @click="serviceChange()">
          Envíar
        </el-button>
        <el-button
            v-if="comments != null && comments.length > 3 && showAddSend"
            icon="fas fa-star"
            @click="addToFavorites(1)">
          Agregar a Favoritos
        </el-button>
        <el-button
            v-if="comments != null && comments.length > 3 && showAddSend"
            icon="fas fa-paper-plane"
            @click="addToFavorites(2)">
          Agregar a Favoritos y Enviar
        </el-button>
        <el-button
            icon="fas fa-eye"
            @click="showFavorites(1)">
          Ver mis Favoritos
        </el-button>
        <el-button
            icon="fas fa-users"
            @click="showFavorites(2)">
          Favoritos por área
        </el-button>
        <el-button
            icon="fas fa-comments"
            @click="showFavorites(3)">
          Todos los comentarios
        </el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex"
import {Notification} from "element-ui";

export default {
  props: {
    submitForm: {
      required: true,
      type: Function
    },
    submitFormValidate: {
      required: true,
      type: Function
    },
    serviceChangeStatus: {
      required: true,
      type: Function
    },
    alias_this: {}
  },
  data() {
    return {
      showDialog: false,
      type: null,
      comments: null,
      allComments: [],
      status: null,
      showAddSend: true,
      statuses: [],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      rate: 1,
      oldCatStatuses: [
        {
          'id': 1,
          'name': 'Registrado',
          'label': 'Guardar',
          'type': 'primary'
        },

        {
          'id': 2,
          'name': 'Enviado al Titular',
          'label': 'Envíar al Titular',
          'type': 'success'
        },

        {
          'id': 3,
          'name': 'Comentado por el Titular',
          'label': 'Rechazado por el titular',
          'type': 'danger'
        },

        {
          'id': 4,
          'name': 'Autorizado por el Titular',
          'label': 'Autorizado por el Titular',
          'type': 'success'
        },

        {
          'id': 5,
          'name': 'En revisión de DGTII',
          'label': 'Guardar',
          'type': 'success'
        },

        {
          'id': 6,
          'name': 'Comentado por DGTII',
          'label': 'Rechazado por DGTII',
          'type': 'danger'
        },

        {
          'id': 7,
          'name': 'En revisión por área de seguridad',
          'label': 'En revisión por área de seguridad',
          'type': 'success'
        },

        {
          'id': 8,
          'name': 'En revisión por área de infraestructura',
          'label': 'En revisión por área de infraestructura',
          'type': 'success'
        },
        {
          'id': 9,
          'name': 'Comentado por áreas técnicas',
          'label': 'Comentado por áreas técnicas',
          'type': 'danger'
        },
        {
          'id': 10,
          'name': 'En predictamen de DGTII',
          'label': 'En predictamen de DGTII',
          'type': 'success'
        },
        // {
        // 	'id': 11,
        // 	'name': 'Rechazado por DGTII',
        // 	'label': 'Rechazado por DGTII',
        // 	'type': 'danger'
        // },
        {
          'id': 12,
          'name': 'Aceptado por DGTII',
          'label': 'Aceptado por DGTII',
          'type': 'success'
        },
        {
          'id': 13,
          'name': 'En revisión del OIC',
          'label': 'En revisión del OIC',
          'type': 'success'
        },
        {
          'id': 14,
          'name': 'Comentado por el OIC',
          'label': 'Comentado por el OIC',
          'type': 'danger'
        },
        {
          'id': 15,
          'name': 'Aceptado por el OIC',
          'label': 'Aceptado por el OIC',
          'type': 'success'
        },
        {
          'id': 16,
          'name': 'En revisión por la UGD',
          'label': 'En revisión por la UGD',
          'type': 'success'
        },
        {
          'id': 17,
          'name': 'Comentado por la UGD',
          'label': 'Comentado por la UGD',
          'type': 'danger'
        },
        {
          'id': 18,
          'name': 'Rechazado por la UGD',
          'label': 'Rechazado por la UGD',
          'type': 'danger'
        },
        {
          'id': 19,
          'name': 'Aceptado por la UGD',
          'label': 'Aceptado por la UGD',
          'type': 'success'
        },
        {
          'id': 20,
          'name': 'En revisión por la SHCP',
          'label': 'En revisión por la SHCP',
          'type': 'success'
        },
        {
          'id': 21,
          'name': 'Comentado por la SHCP',
          'label': 'Comentado por la SHCP',
          'type': 'danger'
        },
        {
          'id': 22,
          'name': 'Rechazado por la SHCP',
          'label': 'Rechazado por la SHCP',
          'type': 'danger'
        },
        {
          'id': 23,
          'name': 'Aceptado por la SHCP',
          'label': 'Aceptado por la SHCP',
          'type': 'success'
        },
        {
          'id': 24,
          'name': 'En revisión por la DGPOP',
          'label': 'En revisión por la DGPOP',
          'type': 'success'
        },
        {
          'id': 25,
          'name': 'Comentado por la DGPOP',
          'label': 'Comentado por la DGPOP',
          'type': 'danger'
        },
        {
          'id': 26,
          'name': 'Sin disponibilidad presupuestaria',
          'label': 'Sin disponibilidad presupuestaria',
          'type': 'danger'
        },
        {
          'id': 27,
          'name': 'Presupuesto autorizado por DGPOP',
          'label': 'Presupuesto autorizado por DGPOP',
          'type': 'success'
        },
        {
          'id': 28,
          'name': 'Solicitud rechazada',
          'label': 'Solicitud rechazada',
          'type': 'danger'
        },
        {
          'id': 29,
          'name': 'Solicitud autorizada',
          'label': 'Solicitud autorizada',
          'type': 'success'
        },
        {
          'id': 30,
          'name': 'En revisión por la UGD / En revisión por la SHCP',
          'label': 'En revisión por la UGD / En revisión por la SHCP',
          'type': 'success'
        },
        {
          'id': 31,
          'name': 'En revisión de Supervisor',
          'label': 'En revisión de Supervisor',
          'type': 'success'
        },
        {
          'id': 32,
          'name': 'Comentando por el Supervisor',
          'label': 'Comentando por el Supervisor',
          'type': 'danger'
        },
        {
          'id': 33,
          'name': 'Aprobado por Área',
          'label': 'Aprobado por Área',
          'type': 'success'
        },

      ],
      catStatuses: [
        // This ID is not in the DB
        {
          'id': 4345,
          'name': 'VoBo DGTII',
          'label': 'Dar Visto Bueno (Infraestructura y Servicios Informáticos)',
          'type': 'success'
        },
        {
          'id': 34,
          'name': 'Registrado',
          'label': 'Guardar',
          'type': 'primary'
        },

        {
          'id': 35,
          'name': 'Enviado a DGTII',
          'label': 'Envíar a DGTII',
          'type': 'success'
        },

        {
          'id': 37,
          'name': 'Enviado a Seguridad',
          'label': 'Envíar a Seguridad',
          'type': 'success'
        },

        {
          'id': 38,
          'name': 'Enviado a Infraestructura',
          'label': 'Envíar a Infraestructura',
          'type': 'success'
        },

        {
          'id': 39,
          'name': 'Enviado a Servicios Informáticos',
          'label': 'Envíar a Servicios Informáticos',
          'type': 'success'
        },

        {
          'id': 40,
          'name': 'Enviado a Director General',
          'label': 'Envíar a Director General',
          'type': 'success'
        },

        {
          'id': 41,
          'name': 'VoBo Seguridad',
          'label': 'Dar Visto Bueno',
          'type': 'success'
        },
        {
          'id': 42,
          'name': 'Comentado por Seguridad',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 43,
          'name': 'VoBo Infraestructura',
          'label': 'Dar Visto Bueno',
          'type': 'success'
        },
        {
          'id': 44,
          'name': 'Comentado por Infraestructura',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 45,
          'name': 'VoBo Servicios Informáticos',
          'label': 'Dar Visto Bueno',
          'type': 'success'
        },
        {
          'id': 46,
          'name': 'Comentado por Servicios Informáticos',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 47,
          'name': 'VoBo Director General',
          'label': 'Dar Visto Bueno',
          'type': 'success'
        },
        {
          'id': 48,
          'name': 'Comentado por Director General',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 49,
          'name': 'Rechazado por DGTII',
          'label': 'Rechazar',
          'type': 'danger'
        },
        {
          'id': 50,
          'name': 'Comentado por DGTII',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 51,
          'name': 'VoBo DGTII',
          'label': 'Envíar a RME',
          'type': 'success'
        },
        {
          'id': 52,
          'name': 'Justificación e Investigación de Mercado',
          'label': 'Guardar',
          'type': 'primary'
        },
        {
          'id': 53,
          'name': 'Envíar a DGTII',
          'label': 'Envíar a DGTII',
          'type': 'success'
        },
        {
          'id': 55,
          'name': 'Comentado por DGTII',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 56,
          'name': 'VoBo DGTII',
          'label': 'Dar Visto Bueno',
          'type': 'success'
        },
        {
          'id': 57,
          'name': 'Envíar a Titular',
          'label': 'Envíar a Titular',
          'type': 'success'
        },
        {
          'id': 58,
          'name': 'Envíar a DGTII',
          'label': 'Envíar a DGTII',
          'type': 'success'
        },
        {
          'id': 59,
          'name': 'Comentado por DGTII',
          'label': 'Comentar',
          'type': 'warning'
        },
        {
          'id': 62,
          'name': 'Rechazado por DGTII',
          'label': 'Rechazar',
          'type': 'danger'
        },
        {
          'id': 63,
          'name': 'Aceptado por DGTII',
          'label': 'Aceptar',
          'type': 'success'
        },
        {
          'id': 64,
          'name': 'En revisión del OIC',
          'label': 'En revisión del OIC',
          'type': 'success'
        },
        {
          'id': 65,
          'name': 'Comentado por el OIC',
          'label': 'Comentado por el OIC',
          'type': 'warning'
        },
        {
          'id': 66,
          'name': 'Aceptado por el OIC',
          'label': 'Aceptado por el OIC',
          'type': 'success'
        },
        {
          'id': 67,
          'name': 'En revisión por la UGD',
          'label': 'En revisión por la UGD',
          'type': 'success'
        },
        {
          'id': 68,
          'name': 'Comentado por la UGD',
          'label': 'Comentado por la UGD',
          'type': 'warning'
        },
        {
          'id': 69,
          'name': 'Rechazado por la UGD',
          'label': 'Rechazado por la UGD',
          'type': 'danger'
        },
        {
          'id': 70,
          'name': 'Aceptado por la UGD',
          'label': 'Aceptado por la UGD',
          'type': 'success'
        },
        {
          'id': 71,
          'name': 'En revisión por la SHCP',
          'label': 'En revisión por la SHCP',
          'type': 'success'
        },
        {
          'id': 72,
          'name': 'Comentado por la SHCP',
          'label': 'Comentado por la SHCP',
          'type': 'warning'
        },
        {
          'id': 73,
          'name': 'Rechazado por la SHCP',
          'label': 'Rechazado por la SHCP',
          'type': 'danger'
        },
        {
          'id': 74,
          'name': 'Aceptado por la SHCP',
          'label': 'Aceptado por la SHCP',
          'type': 'success'
        },
        {
          'id': 75,
          'name': 'En revisión por la DGPOP',
          'label': 'En revisión por la DGPOP',
          'type': 'success'
        },
        {
          'id': 76,
          'name': 'Comentado por la DGPOP',
          'label': 'Comentado por la DGPOP',
          'type': 'warning'
        },
        {
          'id': 77,
          'name': 'Sin disponibilidad presupuestaria',
          'label': 'Sin disponibilidad presupuestaria',
          'type': 'danger'
        },
        {
          'id': 78,
          'name': 'Presupuesto autorizado por DGPOP',
          'label': 'Presupuesto autorizado por DGPOP',
          'type': 'success'
        },
        {
          'id': 79,
          'name': 'Solicitud rechazada',
          'label': 'Solicitud rechazada',
          'type': 'danger'
        },
        {
          'id': 80,
          'name': 'Solicitud autorizada',
          'label': 'Solicitud autorizada',
          'type': 'success'
        },
        {
          'id': 81,
          'name': 'Preautorización por área',
          'label': 'Pre-VoBo',
          'type': 'primary'
        },
        {
          'id': 82,
          'name': 'Pre-Comentario por área',
          'label': 'Pre-Comentar',
          'type': 'danger'
        }

      ],
    }
  },
  computed: {
    ...mapGetters("form", {
      requestForm: "requestForm",
      onlyRead: "onlyRead"
    }),
    profileUser() {
      return this.$store.state.user.profile;
    },
    officeId() {
      return this.$store.state.user.cat_office_id;
    },

    userInfo() {
      return this.$store.state.user.isAuthorizer;
    }
  },

  methods: {

    ...mapMutations('form', {
      resetOnlyRead: "resetOnlyRead"
    }),
    checkShowStatuses(...permission) {
      let array = [];
      array = _.intersectionWith(this.catStatuses, permission,
          ({id}, item) => id == item
      );
      return array;
    },

    goToUp() {
      $('#body-content').animate({scrollTop: 0}, 'slow');
    },

    checkEditMyAcquisition() {

      if (this.requestForm.id &&
          (this.profileUser == 2 || this.profileUser == 3) &&
          this.officeId != this.requestForm.cat_office_id) {
        this.resetOnlyRead(true);
        return true;
      } else {
        return false;
      }
    },
    specialService(item) {
      this.alias_this.$refs['requestForm'].validate((valid) => {
        if (valid) {
          if (this.alias_this.filterSection(this.requestForm.documents, 10) === false) {
            this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Dictamen Técnico Informático Regional".'}, {root: true});
            return true;
          }
          if (this.alias_this.filterSection(this.requestForm.documents, 4) === false) {
            this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Anexo Técnico".'}, {root: true});
            return true;
          }
          if (this.alias_this.filterSection(this.requestForm.documents, 6) === false && this.requestForm.last_log.cat_acquisition_status_id >= 51) {
            this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Investigación de Mercado".'}, {root: true});
            return true;
          }
          if (this.alias_this.filterSection(this.requestForm.documents, 5) === false && this.requestForm.last_log.cat_acquisition_status_id >= 51) {
            this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Justificación".'}, {root: true});
            return true;
          }

          this.alias_this.submitForm(item, 'Se envía para su validación "Investigación de Mercado y Justificación 2020"');
          this.alias_this.serviceChangeStatus(item, 'Se envía para su validación "Investigación de Mercado y Justificación 2020"', this.requestForm.id);
        } else {
          this.$store.dispatch('notifications/warning', {msg: 'Debe completar todos los campos obligatorios'}, {root: true});
        }
      })


    },

    init() {

      this.statuses = [];
      let profile = this.profileUser;
      let status = this.requestForm.last_log.cat_acquisition_status_id;


      if (profile && status) {
        let ArrayPermissionProfile = [];
        //check new feature
        if (this.checkEditMyAcquisition()) {
          return true;
        }
        // end

        if (profile == 2) {

          if (status == 1 || status == 34 || status == 50) {

            ArrayPermissionProfile = [34, 35];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (status == 3) {

            ArrayPermissionProfile = [1, 2];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          /*if (status == 55) {
            ArrayPermissionProfile = [53];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }*/

          if (status == 51 || status == 55 || status == 52) {
            ArrayPermissionProfile = [52, 53];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 59) {
            ArrayPermissionProfile = [52, 58];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 56) {
            ArrayPermissionProfile = [58];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }


        }

        if (profile == 3) {

          if (status == 1) {
            ArrayPermissionProfile = [1, 2];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (status == 3 || status == 32) {
            ArrayPermissionProfile = [1, 2];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 2) {
            ArrayPermissionProfile = [3, 4];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 56) {
            ArrayPermissionProfile = [58];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 57) {
            ArrayPermissionProfile = [58];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

        }

        if (profile == 4) {
          ArrayPermissionProfile = [37, 38, 39, 40, 50];

          if (status == 35
              || status == 37
              || status == 38
              || status == 39
              || status == 40
              || status == 41
              || status == 42
              || status == 43
              || status == 44
              || status == 45
              || status == 46
              || status == 47
              || status == 48) {
            let _lastSecurity = (this.requestForm.toSecurity);
            let _lastInfra = (this.requestForm.toInfra);
            let _lastServices = (this.requestForm.toServices);
            let _lastDg = (this.requestForm.toDG);
            let returnButtons = this.filterAreas(_lastSecurity, _lastInfra, _lastServices, _lastDg);
            ArrayPermissionProfile = returnButtons.default;
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);

          }


          if (status == 35 && (this.requestForm.sendAreas && this.requestForm.sendAreas.length > 0
              && this.requestForm.voAreas && this.requestForm.voAreas.length > 0
              && this.requestForm.voAreas.length == this.requestForm.sendAreas.length)) {
            ArrayPermissionProfile = [50, 51];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 53) {
            ArrayPermissionProfile = [56, 55];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }


          if (status == 58) {
            ArrayPermissionProfile = [59, 62, 63];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 63) {
            ArrayPermissionProfile = [64];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 64) {
            ArrayPermissionProfile = [65, 66];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 65) {
            ArrayPermissionProfile = [64, 49];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 66) {
            ArrayPermissionProfile = [67];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 67) {
            ArrayPermissionProfile = [68, 70];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (status == 68) {
            ArrayPermissionProfile = [69, 67];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 70) {
            ArrayPermissionProfile = [71];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 71) {
            ArrayPermissionProfile = [72, 73, 74];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 72) {
            ArrayPermissionProfile = [71, 73];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 74) {
            ArrayPermissionProfile = [75];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 75) {
            ArrayPermissionProfile = [76, 77, 78];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 76) {
            ArrayPermissionProfile = [75, 77, 78];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }


          if (status == 78) {
            ArrayPermissionProfile = [80];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 77) {
            ArrayPermissionProfile = [78, 76, 75];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 73) {
            ArrayPermissionProfile = [79];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }


        }

        if (/*profile == 8 ||*/ profile == 1) {

          if (status == 31 || status == 9 || status == 11 || status == 14 || status == 17 || status == 6) {
            ArrayPermissionProfile = [7, 8, 32, 10];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

          if (status == 33) {
            ArrayPermissionProfile = [32, 10];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
        }

        if (profile == 5) {
          let _toSecurity = this.requestForm.toSecurity;
          let _voAreas = this.requestForm.voAreas;
          if (_.last(_toSecurity) == 37 || _.last(_toSecurity) == 41 || _.last(_toSecurity) == 81
              || _.last(_toSecurity) == 82
              || status == 37) {
            ArrayPermissionProfile = [41, 42, 81, 82];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (_.last(_toSecurity) == 41 || _.last(_toSecurity) == 42   /*|| (_voAreas.find(up => up == 41) == 41)*/) {
            ArrayPermissionProfile = [];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

        }

        if (profile == 6) {
          let _toInfra = this.requestForm.toInfra;
          let _voAreas = this.requestForm.voAreas;
          if (_.last(_toInfra) == 38 || _.last(_toInfra) == 81 || _.last(_toInfra) == 82) {
            ArrayPermissionProfile = [43, 44, 81, 82];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (_.last(_toInfra) == 43 || _.last(_toInfra) == 44 /*|| (_voAreas.find(up => up == 43) == 43)*/) {
            ArrayPermissionProfile = [];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
        }

        if (profile == 9) {
          let _toServices = this.requestForm.toServices;
          let _voAreas = this.requestForm.voAreas;
          if (_.last(_toServices) == 39 || _.last(_toServices) == 82 || _.last(_toServices) == 81) {
            ArrayPermissionProfile = [45, 46, 81, 82];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (_.last(_toServices) == 45 || _.last(_toServices) == 46 /*|| (_voAreas.find(up => up == 45) == 45)*/) {
            ArrayPermissionProfile = [];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }

        }

        if (profile == 10) {
          let _toDG = this.requestForm.toDG;
          let _voAreas = this.requestForm.voAreas;
          if (_.last(_toDG) == 40 || _.last(_toDG) == 81 || _.last(_toDG) == 82) {
            ArrayPermissionProfile = [47, 48, 81, 82];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
          if (_.last(_toDG) == 47 || _.last(_toDG) == 48 /*|| (_voAreas.find(up => up == 47) == 47)*/) {
            ArrayPermissionProfile = [];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
        }

        if (profile == 11) {
          // Assign infraestructure permissions but on click fire the same to infra and informatics
          // <|::: INFRA :::|>
          let _toInfra = this.requestForm.toInfra;
          if (_.last(_toInfra) == 38 || _.last(_toInfra) == 81 || _.last(_toInfra) == 82) {
            ArrayPermissionProfile.push(43, 44, 81, 82)
          }
          // <|::: INFRA :::|>

          // <|::: SERVICIOS INFORMATICOS :::|>
          // Validate just one group of permissions
          let _toServices = this.requestForm.toServices;
          if (_.last(_toServices) == 39 || _.last(_toServices) == 82 || _.last(_toServices) == 81) {
            ArrayPermissionProfile.push(45, 46, 81, 82);
          }
          // <|::: SERVICIOS INFORMATICOS :::|>

          // VoBo
          if (ArrayPermissionProfile.includes(43) && ArrayPermissionProfile.includes(45)) {
            ArrayPermissionProfile = ArrayPermissionProfile.filter(item => item !== 43 & item !== 45);
            ArrayPermissionProfile.push(4345)
          }

          this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);

          // // Set buttons labels
          let voboInfra = this.catStatuses.find(status => status.id === 43)
          let comentInfra = this.catStatuses.find(status => status.id === 44)
          voboInfra.label = 'Dar Visto Bueno (Infraestructura)'
          comentInfra.label = 'Comentar (Infraestructura)'

          let voboServices = this.catStatuses.find(status => status.id === 45)
          let comentServices = this.catStatuses.find(status => status.id === 46)
          voboServices.label = 'Dar Visto Bueno (Servicios Informáticos)'
          comentServices.label = 'Comentar (Servicios Informáticos)'
        }

        /* if (profile == 7) {

                       if (status == 10) {
                           ArrayPermissionProfile = [11, 13];
                           this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
                       }
                   }*/

        if (profile == 39) {

          if (status == 41) {
            ArrayPermissionProfile = [43, 44];
            this.statuses = this.checkShowStatuses(...ArrayPermissionProfile);
          }
        }
        let _toSecurity = this.requestForm.toSecurity;
        if (_.last(_toSecurity) == 81) {
          this.statuses = _.filter(this.statuses, function (e) {
            return e.id != 81
          })
        }
        if (_.last(_toSecurity) == 82) {
          this.statuses = _.filter(this.statuses, function (e) {
            return e.id != 82
          })
        }

      }

    },

    serviceChange() {
      this.serviceChangeStatus(this.status, this.comments, null);
    },

    deleteComment(row) {
      let _data = {
        ...row
      }
      this.$confirm('Eliminar comentario, ¿desea continuar?').then(confirm => {
        axios.post('/api/d-favorites', _data).then(response => {
          if (response.data.success) {
            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});

            this.showFavorites()
          } else {
            this.$notify.error('No se pudo procesar su solicitud.')
          }
        }).catch(e => {
          console.log("error deleteComment", e)
        })
      }).catch(e => {
        this.$store.dispatch('notifications/warning', {msg: 'No se registró ningun cambio.'}, {root: true});
      });
    },

    addToFavorites(type) {
      let _data = {
        comment: this.comments,
        order: this.rate,
      }
      this.$confirm('Este comentario se agregará a una lista personal de textos creados por usted ' +
          'y se mostrarán como atajos en próximas interacciones, ¿desea continuar?').then(confirm => {
        axios.post('/api/acquisitions/add-favorites', _data).then(response => {
          if (response.data.success) {
            this.$notify.success(response.data.message)
            if (type == 2) {
              this.serviceChange()
            }
          } else {
            this.$notify.error('No se pudo procesar su solicitud.')
          }
        }).catch(e => {
          console.log("error add favorites", e)
        })
      }).catch(e => {
        this.$store.dispatch('notifications/warning', {msg: 'No se registró ningun cambio.'}, {root: true});
      });
    },
    showFavorites(type) {
      this.type = type;
      if (type != 3) {
        axios.get('/api/acquisitions/show-favorites', {params: {type: type}}).then(response => {
          if (response.data.success) {
            this.$notify.success(response.data.message)
            this.allComments = response.data.comments
          } else {
            this.$notify.success(response.data.message)
          }
        }).catch(e => {
          this.$notify.error("No se pudo procesar su solicitud")
          console.log("error add favorites", e)
        })
      } else {
        axios.post('/api/acquisitions/acquisition-comments', {acquisitionId: this.requestForm.hash_id})
            .then(response => {
              let _comments = response.data.acquisition.comments;
              _comments.forEach((up, key) => {
                _comments[key].comment = up.comments
              })
              this.allComments = _comments
              this.$notify.success('Encuentre su comentario en la lista de opciones.')
            }).catch(e => {
          this.$notify.error("No se pudo procesar su solicitud")
          console.log("error add favorites", e)
        });
      }

    },
    showDialogF(status) {
      this.showDialog = true;
      this.status = status;
      this.comments = null;
    },

    filterAreas(security, infra, services, dg) {
      let _default = [37, 38, 39, 40, 50];
      let _lastSecurity = _.last(security);
      let _lastInfra = _.last(infra);
      let _lastServices = _.last(services);
      let _lastDg = _.last(dg);
      let _Security = [];
      let _Infra = [];
      let _Services = [];
      let _DG = [];
      let _voBo = _.uniq(this.requestForm.voAreas);
      let _countVoBo = 0;
      let _dgtii = [];

      if (_lastSecurity == 37) {
        _Security = [];
      }
      if (_lastSecurity == 42) {
        _Security.push(37);
      }

      if (_lastInfra == 38) {
        _Infra = [];
      }
      if (_lastInfra == 44) {
        _Infra.push(38);
      }

      if (_lastServices == 39) {
        _Services = [];
      }
      if (_lastServices == 46) {
        _Services.push(39);
      }

      if (_lastDg == 40) {
        _DG = [];
      }
      if (_lastDg == 48) {
        _DG.push(40);
      }

      if (_lastSecurity == 41 && security.length > 0) {
        _countVoBo++
      }
      if (_lastInfra == 43 && infra.length > 0) {
        _countVoBo++
      }
      if (_lastServices == 45 && services.length > 0) {
        _countVoBo++
      }
      if (_lastDg == 47 && dg.length > 0) {
        _countVoBo++
      }

      if (_voBo.length > 0 && _voBo.length == _countVoBo
          && _.uniq(this.requestForm.sendAreas).length > 0
          && _lastSecurity != 37
          && _lastInfra != 38
          && _lastServices != 39
          && _lastDg != 40

      ) {
        _default.push(51)
      }
      _default = _.concat(_.difference(_default, _.uniq(this.requestForm.sendAreas)), _Security,
          _Infra,
          _Services,
          _DG);

      return {
        default: _default
      };
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    'profileUser'() {
      this.init();
    },
    'requestForm.last_log.cat_acquisition_status_id'() {
      this.init();
    },
    'requestForm.provider_selected.cat_agreement_multiyear_id'() {
      this.init();
    },
    'statuses'(value) {
      if (value && value.length > 0) {
        setTimeout(() => {
          let _isAuthorizer = this.userInfo;
          let _profile = this.profileUser;
          if (_isAuthorizer == false || _isAuthorizer == 0 || _isAuthorizer == null) {
            this.statuses = _.filter(this.statuses, function (e) {
              return e.id != 41 && e.id != 43 && e.id != 45 && e.id != 47 && e.id != 42 && e.id != 44 && e.id != 46 && e.id != 48 && e.id != 4345
            })
          }
          if (_profile == 5 || _profile == 6 || _profile == 9 || _profile == 10 || _profile == 11) {
            if (this.statuses.filter(up => up.id == 81)?.length == 0) {
              this.statuses.push({
                'id': 81,
                'name': 'Preautorización por área',
                'label': 'Pre-VoBo',
                'type': 'primary'
              });
            }
            if (this.statuses.filter(up => up.id == 82)?.length == 0) {
              this.statuses.push({
                'id': 82,
                'name': 'Pre-Comentario por área',
                'label': 'Pre-Comentar',
                'type': 'danger'
              });
            }
          }
        }, 500);
      }
    }
  }

}
</script>


<style scoped>
.row-fix {
  position: fixed;
  z-index: 99;
  bottom: 1.5em;
  right: 2.5em;
}

.buttonFixed {
  margin: 6px;
}


</style>